// extracted by mini-css-extract-plugin
export default {"list":"Memo__list--+s9IV","item":"Memo__item--yCRsY","title":"Memo__title--5B0lj","meta":"Memo__meta--tGbUL","empty":"Memo__empty--cIqlN"};